import { OrderedData } from '../components/CampaignOrder';

// Mock ordered data - replace with actual data from props/state/API
export const MOCK_ORDERED_DATA: OrderedData[] = [
  {
    id: 1,
    title: '4x Manual Submissions (Update)',
    price: 20
  },
  {
    id: 2,
    title: '4x Manual Submissions (Create)',
    price: 20
  },
  {
    id: 3,
    title: '4x Remove Harmful Duplicate Listings',
    price: 20
  }
];


// Constants
export const DEFAULT_SELECTED_IDS = [1, 2, 3, 4];
export const DEFAULT_TOTAL_PRICE = 20.0;
export const DEFAULT_DUPLICATE_COUNT = 8;
export const DEFAULT_AVAILABLE_NEW_SELECTED_IDS = [1, 3, 4, 5];
export const DEFAULT_AVAILABLE_NEW_TOTAL_PRICE = 25.0;



export const DEFAULT_PRICE_FOR_AVAILABLE_NEW_CITATIONS = 6.25;
export const DEFAULT_PRICE_FOR_REMOVE_DUPLICATES = 0.5;
